import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/ui/BackButton";

export const JobNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="p-6">
      <PageHeader title={t("jobs.notFound.title", "Job Offer Not Found")} />
      <div className="mb-6">
        <BackButton 
          to="/jobs" 
          label={t("jobs.notFound.back", "Back to job offers")} 
        />
      </div>
      <div className="bg-white rounded-sm shadow p-6 text-center">
        <p className="text-gray-600 mb-4">{t("jobs.notFound.message", "The job offer you're looking for doesn't exist or couldn't be loaded.")}</p>
        <Link to="/jobs">
          <Button>{t("jobs.notFound.viewAll", "View All Job Offers")}</Button>
        </Link>
      </div>
    </div>
  );
};
